export const ko = {
    'nav.today': "오늘의 개요",
    'nav.calendar': "수요 캘린더",
    'nav.rates': "요금 및 규칙",
    'nav.automation': "자동화 센터",
    'nav.audit': "감사 로그",
    'nav.settings': "설정",
    'sidebar.status': "연결됨",
    'stat.occupancy': "점유율",
    'stat.adr': "평균 객실료 (ADR)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "예상 수익",
    'stat.trend.vsLastWeek': "지난주 대비",
    'stat.trend.onPace': "순조로움",
    'dashboard.actions.title': "권장 조치",
    'dashboard.actions.empty': "조치를 찾을 수 없습니다.",
    'filter.all': "전체",
    'filter.pricing': "가격 책정",
    'filter.restriction': "제한",
    'action.approve': "승인 및 푸시",
    'action.reject': "거부",
    'action.risk.low': "낮은 위험",
    'action.risk.medium': "중간 위험",
    'action.risk.high': "높은 위험",
    'action.label.current': "현재",
    'action.label.proposed': "제안됨",
    'action.metric.impact': "영향",
    'action.metric.why': "이유",
    'action.status.executed': "자동 실행됨",
    'header.search': "검색...",
    'header.logout': "로그아웃",
    'auto.level.title': "오토파일럿 레벨",
    'auto.level.manual': "수동",
    'auto.level.manual.desc': "모든 권장 사항을 직접 승인합니다.",
    'auto.level.assisted': "보조",
    'auto.level.assisted.desc': "낮은 위험 자동 승인. 주요 변경 사항 검토.",
    'auto.level.auto': "완전 자동",
    'auto.level.auto.desc': "AI가 설정된 범위 내에서 24/7 가격을 관리합니다.",
    'auto.level.active': "활성",
    'auto.guardrails.title': "안전 가드레일",
    'auto.guardrails.maxIncrease': "일일 최대 인상",
    'auto.guardrails.maxIncrease.desc': "가격 급등 방지.",
    'auto.guardrails.maxDecrease': "일일 최대 인하",
    'auto.guardrails.maxDecrease.desc': "지나친 가격 하락 방지.",
    'auto.guardrails.minRate': "최저 요금",
    'auto.guardrails.minRate.desc': "이 가격(순액) 미만으로 판매하지 않음.",
    'auto.emergency.title': "비상 제어",
    'auto.emergency.label': "비상 정지",
    'auto.emergency.desc': "모든 자동화를 즉시 일시 중지합니다.",
    'auto.emergency.btn': "시스템 일시 중지",
    'rates.filter.all': "모든 객실 유형",
    'rates.filter.next14': "향후 14일",
    'rates.export': "내보내기",
    'audit.table.time': "시간",
    'audit.table.actor': "작업자",
    'audit.table.category': "카테고리",
    'audit.table.action': "작업",
    'audit.table.details': "세부 정보",
    'audit.table.status': "상태",
    'settings.pms.title': "PMS 연결",
    'settings.pms.connected': "연결됨:",
    'settings.pms.disconnect': "연결 해제",
    'settings.account.title': "계정",
    'settings.account.role': "역할",
    'settings.restart': "온보딩 다시 시작",
    'onboard.title': "PMS 연결",
    'onboard.desc': "재고 동기화를 위해 자산 관리 시스템을 선택하십시오.",
    'onboard.connecting': "연결 중...",
    'onboard.connect': "연결",
    'onboard.success.title': "설정 완료!",
    'onboard.success.desc': "**SynthHotel Berlin** 동기화되었습니다.",
    'onboard.success.sub': "3가지 객실 유형, 14가지 요금제, 243건의 예약을 가져왔습니다.",
    'onboard.btn.dashboard': "대시보드로 이동",
    'action.dynamic.weekend.title': "주말 요금 인상",
    'action.dynamic.weekend.desc': "토요일 점유율 75% 초과, 수요 강세(24시간 내 +12 객실).",
    'action.dynamic.minstay.title': "2박 최소 숙박 활성화",
    'action.dynamic.minstay.desc': "테일러 스위프트 콘서트 발표. 1박 체류 방지.",
    'action.dynamic.distress.title': "요금 인하 (수요 저조)",
    'action.dynamic.distress.desc': "다음 주 화요일 점유율 35%. 경쟁사 10유로 인하.",
    'action.dynamic.gap.title': "공실 채우기: CTA 제거",
    'action.dynamic.gap.desc': "1박 공실 발견. 판매를 위해 '도착 제한(CTA)' 제거.",
};
